// Core
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { Observable, BehaviorSubject } from 'rxjs';
import { Login, LoginClient } from '@core/interfaces/login';
import { Subscriber } from 'rxjs';

// Services
import { HttpClienteService } from '@core/services/http-cliente.service';
import { LocalStorageService } from '@core/services/local-storage.service';
import { BrazeService } from '@core/services/braze/braze.service';

@Injectable({
  providedIn: 'root',
})

export class AuthListClientService {
  
  useIsLogIn

  private token:string;
  private readonly url = environment.apiURL;
  private obsIsLoggedIn: Observable<boolean>;
  private subscriberIsLoggedIn: Subscriber<boolean> | undefined;
  user : any;

  constructor(
    public readonly router: Router,
    private readonly _http: HttpClienteService,
    private readonly _localStorageService: LocalStorageService,
    private readonly brazeService: BrazeService
  ) {
    this.token = this.getToken();
    if (this.isLoggedIn()) {
      const existingUser = this.getUser();
      if (existingUser?.type === 'Vendedor' && existingUser?.email) {
        this.brazeService.initialize();

        const currentPath = window.location.pathname;
        const isInMainRoutes = currentPath.startsWith('/main');
        const isInTiendaRoutes = currentPath.startsWith('/tienda');
        const clientSelect = this._localStorageService.getItem('clientSelect');
        const hasSelectedClient = !!(clientSelect?.code && clientSelect?.sector);
        const isClientFacingRoute = isInMainRoutes || isInTiendaRoutes;

        setTimeout(() => {
          if (isClientFacingRoute && hasSelectedClient) {
            // F5 en /main o /tienda con cliente activo → Braze como ese cliente (mismo criterio que la campana)
            // console.log('[Braze] Restaurando sesión como Cliente (F5 en /main o /tienda)', {
            //   userId: clientSelect.code,
            //   attributes: { email: clientSelect.email ?? '', name: clientSelect.name ?? '' },
            // });
            this.brazeService.identifyUser(clientSelect.code, {
              email: clientSelect.email ?? '',
              name: clientSelect.name ?? '',
            });
          } else if (!isClientFacingRoute) {
            // F5 fuera de zona cliente (/main, /tienda) → vendedor
            // console.log('[Braze] Restaurando sesión como Vendedor', {
            //   userId: existingUser.email,
            //   attributes: { email: existingUser.email, name: existingUser.fullName ?? '' },
            // });
            this.brazeService.identifyUser(existingUser.email, {
              email: existingUser?.email || '',
              name: existingUser?.fullName || '',
            });
          }
        }, 1000);
      }
    }
    this.useIsLogIn = new BehaviorSubject(this.getUser)
    this.obsIsLoggedIn = new Observable((subscriber) => {
      this.subscriberIsLoggedIn = subscriber;
      this.subscriberIsLoggedIn && this.subscriberIsLoggedIn.next(this.isLoggedIn())
    })
  }

  subscribeIsLoggedIn(): Observable<boolean>{
    return this.obsIsLoggedIn
  }

  pushIsLoggedIn(): void{
    this.subscriberIsLoggedIn && this.subscriberIsLoggedIn.next(this.isLoggedIn());
  }

  getToken(): string {
    return this.getUser() ?
    (this.getUser().token && this.getUser().token != "" ? this.getUser().token : "") : "";
  }

  getUser() {
    const user = this._localStorageService.getItem('user');
    return Object.keys(user).length !== 0 ? user: null;
  }

  setUser(obj: any) {
    this._localStorageService.setItem('user', obj);
    this.token = this.getToken();
    if (this.token) {
      this.pushIsLoggedIn();
      this.brazeService.initialize();
      if (obj?.email) {
        this.brazeService.identifyUser(obj.email, {
          email: obj?.email || '',
          name: obj?.fullName || ''
        });
        this.brazeService.requestPushPermission().catch(() => {});
      }
    }
    this.user = this.getUser();
  }

  removeUser() {
    this._localStorageService.removeItem('user');
    this._localStorageService.removeItem('sectors');
    this._localStorageService.removeItem('sectorSelect');
    this.token = this.getToken();
    this.user = this.getUser();
  }

  getSector() {
    return this._localStorageService.getItem('sectorSelect');
  }
  isSectorSelect(): boolean {
    const sector = this.getSector();
    return Object.keys(sector).length !== 0
  }

 login(obj: Login){
    const query = `${this.url}/wcl-authentication/login`;
    return this._http.post(query,obj);
  }
  loginListClient(obj: LoginClient){
    const query = `${this.url}/wcl-authentication/seller-login`;
    return this._http.post(query,obj);
  }
  logout() {
    this._localStorageService.cleanStore();
    this.pushIsLoggedIn();
    this.router.navigate(['/login']);
  }

  isLoggedIn(): boolean {
    const token = this.getToken();
    return Object.keys(token).length !== 0
  }

  getInformation(obj){
    const query = `${this.url}/wcl-customer/address-delivery?code=${obj.code}&sector=${obj.sector}`;
    return this._http.get(query);
  }

}
